import React from "react";
import HomePage from "./components/HomePage";
import "./App.css";
import { Analytics } from "@vercel/analytics/react";
import { BrowserRouter, Route, Routes, Outlet } from "react-router-dom";
import ChennaiLogin from "./Chennai/auth/ChennaiLogin";
import ChennaiProfile from "./Chennai/components/Chennaiprofile";
import Navbar from "./Chennai/components/Navbar";
import AdminDashboard from "./Chennai/Admin/pages/AdminDashboard";
import ChennaiAdminAddProject from "./Chennai/Admin/pages/AddProject";
import ChennaiAdminAddUser from "./Chennai/Admin/pages/AddUser";
import MetricsPage from "./Chennai/Admin/pages/MetricsPage";
import ChennaiAllUsers from "./Chennai/Admin/pages/AllUser";
import ChennaiAllProjects from "./Chennai/Admin/pages/AllProjects";
import UserDashboard from "./Chennai/User/pages/UserDashboard";

import UrjabioLogin from "./Urjabio/auth/UrjabioLogin";
import UrjabioProfile from "./Urjabio/components/Urjabioprofile";
import UrjabioNavbar from "./Urjabio/components/UrjabioNavbar";
import UrjabioAdminDashboard from "./Urjabio/Admin/pages/UrjabioAdminDashboard";
import UrjabioAdminAddProject from "./Urjabio/Admin/pages/UrjabioAddProject";
import UrjabioAdminAddUser from "./Urjabio/Admin/pages/UrjabioAddUser";
import UrjabioMetricsPage from "./Urjabio/Admin/pages/UrjabioMetricsPage";
import UrjabioAllUsers from "./Urjabio/Admin/pages/UrjabioAllUser";
import UrjabioAllProjects from "./Urjabio/Admin/pages/UrjabioAllProjects";
import UrjabioUserDashboard from "./Urjabio/User/pages/UrjabioUserDashboard";

// For admindashboard

import Users from "./Kuppismart_Admin/pages/User";
import AddUser from "./Kuppismart_Admin/pages/AddUser";
import EditUser from "./Kuppismart_Admin/pages/EditUser";
import AddDevices from "./Kuppismart_Admin/pages/AddDevices";
import Category from "./Kuppismart_Admin/pages/Category";
import AddEditCategory from "./Kuppismart_Admin/pages/AddEditCategory";
import ProductsList from "./Kuppismart_Admin/pages/ProductList";
import BlogList from "./Kuppismart_Admin/pages/BlogList";
import AddBlog from "./Kuppismart_Admin/pages/AddBlog";
import Quotes from "./Kuppismart_Admin/pages/Quotes";
import EditBlog from "./Kuppismart_Admin/pages/EditBlog";
import Coupons from "./Kuppismart_Admin/pages/Coupons";
import AddEditCoupon from "./Kuppismart_Admin/pages/AddEditCoupons";
import FarmOverviewUpload from "./Kuppismart_Admin/pages/FarmOverviewUpload.jsx";
import MortalityUpdate from "./Kuppismart_Admin/pages/MortalityUpload.jsx";
import CameraFeedUpload from "./Kuppismart_Admin/pages/CameraFeedUpload.jsx";
import CarouselManager from "./Kuppismart_Admin/pages/CaroselManager.jsx";
import AddEditCarouselImage from "./Kuppismart_Admin/pages/AddEditCarousel.jsx";
import Queries from "./Kuppismart_Admin/pages/Queries.jsx";
import Collaborators from "./Kuppismart_Admin/pages/Collaborators";
import AddEditCollaborators from "./Kuppismart_Admin/pages/AddEditcollaborators";
import BehindTheIdea from "./Kuppismart_Admin/pages/BehindtheIdea.jsx";
import AddEditBehindTheIdea from "./Kuppismart_Admin/pages/AddEditIdea.jsx";
import Testimonials from "./Kuppismart_Admin/pages/Testamonials.jsx";
import AddEditTestimonial from "./Kuppismart_Admin/pages/AddEditTestimonials.jsx";
import Login from "./Kuppismart_Admin/pages/Login.jsx";
import EditDevices from "./Kuppismart_Admin/pages/EditDevice.jsx";
import AddEditProduct from "./Kuppismart_Admin/pages/AddEditProduct.jsx";

//  kupposmart new wesbite
import NewHomePage from "./components/NewHomePage";
import AquaMonitoring from "./components/AquaMonitoring";
import STPMonitoring from "./components/STPMonitoring";
import NewAboutUs from "./components/NewAboutUs";
import NewBlogPage from "./components/NewBlogPage";
import GasMonitoring from "./components/GasMonitoring";

function ChennaiAdminShell() {
  return (
    <div className="flex min-h-screen flex-col bg-gray-100">
      <Navbar />
      <main className="min-w-0 w-full flex-1 px-3 py-4 sm:px-4 sm:py-5 md:px-8 md:py-6 lg:px-10">
        <Outlet />
      </main>
    </div>
  );
}

function ChennaiUserShell() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar userType="user" />
      <main className="min-w-0 w-full flex-1 px-3 py-4 sm:px-4 sm:py-5 md:px-8 md:py-6 lg:px-10">
        <Outlet />
      </main>
    </div>
  );
}

function UrjabioAdminShell() {
  return (
    <div className="relative flex min-h-screen flex-col bg-[#f2fbf4]">
      <div className="relative z-50 shrink-0">
        <UrjabioNavbar />
      </div>
      <main className="relative z-10 min-w-0 w-full flex-1 px-3 py-4 sm:px-4 sm:py-5 md:px-8 md:py-6 lg:px-10">
        <Outlet />
      </main>
    </div>
  );
}

function UrjabioUserShell() {
  return (
    <div className="relative min-h-screen bg-[#f2fbf4]">
      <div className="relative z-50 shrink-0">
        <UrjabioNavbar userType="user" />
      </div>
      <main className="relative z-10 min-w-0 w-full flex-1 px-3 py-4 sm:px-4 sm:py-5 md:px-8 md:py-6 lg:px-10">
        <Outlet />
      </main>
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <div className="App">
        <Analytics />
        <Routes>
          {/* <Route path="/" element={<HomePage />} /> */}
          <Route path="/chennai-login" element={<ChennaiLogin />} />
          <Route path="/chennaiprofile" element={<ChennaiProfile />} />
          <Route path="/chennai/admin" element={<ChennaiAdminShell />}>
            <Route path="dashboard" element={<AdminDashboard />} />
            <Route path="add-project" element={<ChennaiAdminAddProject />} />
            <Route path="add-user" element={<ChennaiAdminAddUser />} />
            <Route path="metrics/:projectId" element={<MetricsPage />} />
            <Route path="chennaiprofile" element={<ChennaiProfile />} />
            <Route path="all-users" element={<ChennaiAllUsers />} />
            <Route path="all-projects" element={<ChennaiAllProjects />} />
          </Route>
          <Route path="/chennai-user" element={<ChennaiUserShell />}>
            <Route path="dashboard" element={<UserDashboard />} />
            <Route path="chennaiprofile" element={<ChennaiProfile />} />
          </Route>

          <Route path="/urjabio-login" element={<UrjabioLogin />} />
          <Route path="/urjabioprofile" element={<UrjabioProfile />} />
          <Route path="/urjabioadminprofile" element={<UrjabioProfile />} />
          <Route path="/urjabio/admin" element={<UrjabioAdminShell />}>
            <Route path="dashboard" element={<UrjabioAdminDashboard />} />
            <Route path="add-project" element={<UrjabioAdminAddProject />} />
            <Route path="add-user" element={<UrjabioAdminAddUser />} />
            <Route path="metrics/:projectId" element={<UrjabioMetricsPage />} />
            <Route path="urjabioprofile" element={<UrjabioProfile />} />
            <Route path="all-users" element={<UrjabioAllUsers />} />
            <Route path="all-projects" element={<UrjabioAllProjects />} />
          </Route>
          <Route path="/urjabio-user" element={<UrjabioUserShell />}>
            <Route path="dashboard" element={<UrjabioUserDashboard />} />
            <Route path="urjabioprofile" element={<UrjabioProfile />} />
          </Route>

          {/* new routing for Kuppismart Admin dashboard  */}
          <Route path="/all-users" element={<Users />} />
          <Route path="/add-user" element={<AddUser />} />
          <Route path="/add-devices" element={<AddDevices />} />
          <Route path="/category" element={<Category />} />
          <Route path="/add-category" element={<AddEditCategory />} />
          <Route path="/product-category/:id" element={<AddEditCategory />} />
          <Route path="/products-list" element={<ProductsList />} />
          <Route path="/add-product" element={<AddEditProduct />} />
          <Route path="/edit-product/:id" element={<AddEditProduct />} />
          <Route path="/blog" element={<BlogList />} />
          <Route path="/add-blog" element={<AddBlog />} />
          <Route path="/users/edit/:id" element={<EditUser />} />
          <Route path="/users/edit/:id/devices" element={<EditDevices />} />
          <Route path="/quotes" element={<Quotes />} />
          <Route path="/edit-blog/:id" element={<EditBlog />} />
          <Route path="/coupons" element={<Coupons />} />
          <Route path="/coupons/add" element={<AddEditCoupon />} />
          <Route path="/coupons/edit/:id" element={<AddEditCoupon />} />
          <Route path="/ml/farm-overview" element={<FarmOverviewUpload />} />
          <Route path="/ml/mortality" element={<MortalityUpdate />} />
          <Route path="/ml/camera-feed" element={<CameraFeedUpload />} />
          <Route path="/uploads/carousel" element={<CarouselManager />} />
          <Route
            path="/uploads/carousel/add"
            element={<AddEditCarouselImage />}
          />
          <Route
            path="/uploads/carousel/edit/:id"
            element={<AddEditCarouselImage />}
          />
          <Route path="/queries" element={<Queries />} />
          <Route path="/uploads/collaborators" element={<Collaborators />} />
          <Route
            path="/uploads/collaborators/add"
            element={<AddEditCollaborators />}
          />
          <Route
            path="/uploads/collaborators/edit/:id"
            element={<AddEditCollaborators />}
          />
          <Route path="/uploads/behind-idea" element={<BehindTheIdea />} />
          <Route
            path="/uploads/behind-idea/add"
            element={<AddEditBehindTheIdea />}
          />
          <Route
            path="/uploads/behind-idea/edit/:id"
            element={<AddEditBehindTheIdea />}
          />
          <Route path="/uploads/testimonials" element={<Testimonials />} />
          <Route
            path="/uploads/testimonials/add"
            element={<AddEditTestimonial />}
          />
          <Route
            path="/uploads/testimonials/edit/:id"
            element={<AddEditTestimonial />}
          />
          <Route path="/admin-login" element={<Login />} />
          <Route path="/users/edit/:userId/devices" element={<EditDevices />} />

          {/* new routes for Kuppismart website */}

          <Route path="/" element={<NewHomePage />} />
          <Route path="/aqua-monitoring" element={<AquaMonitoring />} />
          <Route path="/stp-monitoring" element={<STPMonitoring />} />
          <Route path="/gas-monitoring" element={<GasMonitoring />} />
          <Route path="/about" element={<NewAboutUs />} />
          <Route path="/new-blog" element={<NewBlogPage />} />

        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
